package com.xtream.composeapp.di
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.presentation.ui.search.SearchScreenViewModel
import com.xtream.composeapp.viewmodel.AdViewModel
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.DataLoaderViewModel
import com.xtream.composeapp.viewmodel.DominantColorViewModel
import com.xtream.composeapp.viewmodel.HomeViewModel
import com.xtream.composeapp.viewmodel.PlayerServerViewModel
import com.xtream.composeapp.viewmodel.SearchViewModel
import com.xtream.composeapp.viewmodel.SelectedStreamTypeViewModel
import com.xtream.composeapp.viewmodel.SeriesInfoViewModel
import com.xtream.composeapp.viewmodel.SeriesViewModel
import com.xtream.composeapp.viewmodel.ServerConfigViewModel
import com.xtream.composeapp.viewmodel.TmdbViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.composeapp.viewmodel.VodInfoViewModel
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.composeapp.viewmodel.livetv.LiveStreamsViewModel
import com.xtream.composeapp.viewmodel.livetv.SelectedTVchanelLiveModel
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module


@OptIn(KoinExperimentalAPI::class)
val viewModelModules = module {
  viewModel { params ->
    // Try to get the parameter at index 0 (Screen).
    // If it's missing (null), use Screen.Loading() as the default.
    val route = params.getOrNull<Screen>() ?: Screen.Loading()

    RootNavViewModel(initialRoute = route)
  }
  viewModelOf(::AdViewModel)
  viewModelOf(::StreamControlViewModel)
  viewModelOf(::AppSettingsViewModel)
  viewModelOf(::LiveStreamsViewModel)
  viewModelOf(::SeriesViewModel)
  viewModelOf(::SelectedTVchanelLiveModel)
  viewModelOf(::SearchViewModel)
  viewModelOf(::VodStreamsViewModel)
  viewModelOf(::HomeViewModel)
  viewModelOf(::VodInfoViewModel)
  viewModel{ (id: Int?)->
    VodInfoViewModel( get(), get(), get(), id)
  }
  viewModelOf(::UserViewModel)
  viewModelOf(::ServerConfigViewModel)
  viewModelOf(::SeriesInfoViewModel)
  viewModelOf(::PlayerServerViewModel)
  viewModel { (id: Int?) ->
    SeriesInfoViewModel( get(), get(), get(), id)
  }
  viewModelOf(::SelectedStreamTypeViewModel)
  viewModelOf(::DataLoaderViewModel)
  viewModelOf(::DominantColorViewModel)
  viewModelOf(::TmdbViewModel)
  viewModelOf(::SearchScreenViewModel)




}

